import { FiltersParams, GetGroupsFilters } from 'types';
import { groupsFilterFields } from 'consts/group/groupsFilterFields';

export const parseFilterParamsIntoGetGroupsFiltersValues: (
    filterParams: FiltersParams,
    searchFilterParam: string,
) => GetGroupsFilters = (filterParams, searchFilterParam) => ({
    search: searchFilterParam || undefined,
    fromYear: filterParams[groupsFilterFields.fromYear]
        ? Number(filterParams[groupsFilterFields.fromYear])
        : undefined,
    toYear: filterParams[groupsFilterFields.toYear]
        ? Number(filterParams[groupsFilterFields.toYear])
        : undefined,
});
